import React from "react";
import clsx from "clsx";
import s from "./TableRow.less";
import Button from "~/shared/ui/Fields/Button";

interface IProps {
  options: string[];

  item;
}

const ProjectDocumentTableRow: React.FC<IProps> = ({
  options = [],

  item = {},
}) => {
  return (
    <>
      <tr className={s.row_tr}>
        {options?.map((optionName) => (
          <td
            className={clsx({})}
            key={optionName}
            data-option_name={optionName}
          >
            {optionName === "Link" ? (
              <a
                href={item.File.link}
                download
                target="_blank"
                placeholder={item.File.name}
              >
                <Button txtBtn={"Скачать файл"} small orange />
              </a>
            ) : (
              <div>{item[optionName]}</div>
            )}
          </td>
        ))}
      </tr>
    </>
  );
};
export default ProjectDocumentTableRow;
